import React from "react";

interface Props {
  id?: string;
  className: string;
  children: React.ReactNode;
  href: string;
}

const LinkButton = ({ id, className, href, children }: Props) => (
  <a id={id} className={`${className}`} href={href}>
    {children}
  </a>
);

export default LinkButton;
